module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_waso_studio@3x-73bec54ded538c276c39376d24bca34f.webp";